angular.module('PTK.services.Message', [])

.factory('Message', ['$rootScope', function($rootScope) {

    var uzenet = {};

    uzenet.szoveg = '';

    uzenet.prepForBroadcast = function(msg) {
		
		//console.log ("Üzenet:" + msg);
		
        this.szoveg = msg;
        this.broadcastItem();
    };

    uzenet.broadcastItem = function() {
        $rootScope.$broadcast('handleBroadcast');
    };

    return uzenet;
}]);
